function cstLogoScroller() {
  let secAnim = 20;

  let $logoScrollerMainContainer = $('.marquee__container');
  let $logoScrollerTrack = $('.marquee__track');
  let $logoScrollerMainTrack = $(
    '.marquee__track:not(.marquee__track--copied)'
  );

  let $logoScrollerCopiedTrack = $('.marquee__track.marquee__track--copied');
  $logoScrollerCopiedTrack.remove();

  if ($logoScrollerMainContainer.length && $logoScrollerTrack.length) {
    let containerWidth = $logoScrollerMainContainer.width();
    let logoScrollerMainTrackWidth = $logoScrollerMainTrack.get(0).scrollWidth;

    let tracksWidth = getTracksWidth();

    let containerWidth_X2 = containerWidth * 2;

    let maxCount = containerWidth_X2 / logoScrollerMainTrackWidth;
    maxCount = Math.ceil(maxCount);

    let counter = 0;

    do {
      let trackHtml = $logoScrollerMainTrack.html();

      if (trackHtml) {
        let $copiedTrack = $(
          '<div class="marquee__track marquee__track--copied">'
        ).html(trackHtml);

        $logoScrollerMainTrack.after($copiedTrack);
      } else {
        break;
      }

      tracksWidth = getTracksWidth();

      counter++;
    } while (tracksWidth < containerWidth_X2 && counter < maxCount);

    secAnim = secAnim * (logoScrollerMainTrackWidth / containerWidth);

    $logoScrollerMainContainer.css(
      '--width-for-anim',
      logoScrollerMainTrackWidth * -1 + 'px'
    );
    $logoScrollerMainContainer.css('--sec-for-anim', secAnim + 's');
  }

  function getTracksWidth() {
    $logoScrollerTrack = $('.marquee__track');

    let result = 0;

    $logoScrollerTrack.each(function () {
      result += $(this).get(0).scrollWidth;
    });

    return result;
  }
}

$(window).on('load resize', cstLogoScroller);
